import { useEffect } from 'react';
import { App } from 'antd';
import {
  registerAppNotification,
  unregisterAppNotification,
} from '../../utils/appNotification';

/** Wires antd App.useApp() notifications for code outside the React tree (axios, etc.). */
export default function AppNotificationBridge() {
  const { notification } = App.useApp();

  useEffect(() => {
    registerAppNotification(notification);
    return () => unregisterAppNotification();
  }, [notification]);

  return null;
}
